import React, { useEffect, useState } from 'react'
import { Image, Form } from 'react-bootstrap'
import logo from '../../assets/FAEX_Logo.png'

const TabletContainer = () => {
    const userName = sessionStorage.getItem("username")
    const serverVersion = sessionStorage.getItem("serverVersion")

    const [dateTime, setDateTime]= useState(new Date().toLocaleString())

    useEffect(() => {
        var timer = setInterval(() => setDateTime(new Date().toLocaleString()), 1000)

        return function cleanup() {
            clearInterval(timer)
        }
    })

    const getServerVersionHeadline = () => {
        if (typeof (serverVersion) == "string" && serverVersion.length > 0)
            return " (" + serverVersion + ")";
        else
            return "";
    }

    return (
        <div >
            <Form.Group className="leftHeader">
                <Image className="headerImage" src={logo} rounded />
            </Form.Group>
            
            <Form.Group className="rightHeader ">
                <div>{dateTime}</div>
                <div className="rightHeader-userName">{(userName !== "" ? userName : "Username")} <p className="server-environment">{getServerVersionHeadline()}</p></div>
            </Form.Group>
        </div>
    )
}
export default TabletContainer